import React, { useContext } from "react";
import moment from "moment/moment";
import { IntlContext } from "context";
import { BookingContext } from "app/OurService/Booking/Context";
import { SubCategory } from "types/subCategory";

import GardeningFields from "./Gardening/GardeningFields";
import AssistanceFields from "./Assistance/AssistanceFields";
import ChildCareFields from "./ChildCare/ChildCareFields";
import HouseKeepingFields from "./HouseKeeping/HouseKeepingFields";
import TutoringFields from "./Tutoring/TutoringFields";

const AdditionalFields: React.FC = () => {
    const intl = useContext(IntlContext);
    const booking = useContext(BookingContext);

    const renderSubcategoryFields: React.FC<void> = () => {
        const subcategory = booking.getBooking()?.subcategory;

        switch (subcategory) {
            case SubCategory.TROUBLESHOOTING:
            //case SubCategory.REPAIR:
            case SubCategory.ADMINISTRATIVE:
            case SubCategory.INTERNET_USE:
                /* SubCategory.JOB_SEARCHING:*/
                return <AssistanceFields />;
            case SubCategory.BABYSITTING_DURING_WEEK:
            case SubCategory.BABYSITTING_DURING_WEEKEND:
                return <ChildCareFields />;
            case SubCategory.PLANTATION:
            case SubCategory.TERRACE:
            case SubCategory.TRIMMING:
            case SubCategory.OUTDOOR_CLEANING:
                return <GardeningFields />;
            case SubCategory.CLEANING:
            case SubCategory.IRONING:
            case SubCategory.LAUNDRY:
                return <HouseKeepingFields />;
            case SubCategory.HOMEWORK:
            case SubCategory.FOREIGN_LANGUAGES:
            case SubCategory.OTHER_LESSON:
                return <TutoringFields />;
            default:
                return <></>;
        }
    };

    return (
        <>
            <div className="flex flex--wrap">
                <div>
                    <h3>
                        <span className={"text-color--" + booking.getBooking()?.category.toString().toLocaleLowerCase()}>{/*TOO-DOO*/}
                            {booking.getBooking()?.subcategory ?
                                intl.formatMessage(`service.label.subcategory.${booking.getBooking()?.subcategory}`)
                                : intl.formatMessage(`service.label.category.${booking.getBooking()?.category}`
                            )}
                        </span>
                        {intl.formatMessage(`our_services.form.label.additional_information.date_time_title`, {
                            date: moment(booking.getBooking()?.date).format("D MMMM YYYY"),
                            time: moment(booking.getBooking()?.start_time, "HH:mm:ss").format("HH:mm"),
                        })}
                        {intl.formatMessage(`our_services.form.label.additional_information.duration_time_title`, {
                            duration: booking.getBooking()?.nb_hours,
                        })}
                        <div className="italic" style={{ fontSize:"16px" }}>Par : { booking?.getService()?.provider.first_name }</div>
                    </h3>
                </div>
            </div>
            {renderSubcategoryFields()}
        </>
    );
};

export default AdditionalFields;
